import NotFound from "../views/exception/404";
import NoServer from "../views/exception/500";
import NoPermission from "../views/exception/403";
import APPHome from "../views/app-home";
// 权限路由和非权限路由

export const permissonRouters = [
];

export const commonRouters = [
  {
    path: "/",
    element: <APPHome />,
  },
  {
    path: "/app-home",
    element: <APPHome />,
  },
  {
    path: "/exception/404",
    element: <NotFound />,
  },
  {
    path: "/exception/500",
    element: <NoServer />,
  },
  {
    path: "/exception/403",
    element: <NoPermission />,
  },
  {
    path: "*",
    element: <APPHome />,
  },
];

export const allRoutes = [...permissonRouters, ...commonRouters];
